export const module = {
  info: {
    name: 'voip_user_division_profit_percents',
    caption: 'Division User Percent',
    viewGroup: 'users'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Division User Percent',
    icon: 'el-icon-coin',
    routeName: 'module->voip_user_division_profit_percents->create',
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip_user_division_profit_percents->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip_user_division_profit_percents->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
